import * as Sentry from "@sentry/react";

type BootstrapData = {
	sentryDsn?: string;
	release?: string;
	environment?: string;
	geo?: { country?: string };
};

function getBootstrapData(): BootstrapData | undefined {
	return (window as unknown as { __BOOTSTRAP_DATA__?: BootstrapData })
		.__BOOTSTRAP_DATA__;
}

export function init(): void {
	const data = getBootstrapData();
	const dsn = data?.sentryDsn;
	if (!dsn) return;

	Sentry.init({
		dsn,
		release: data?.release,
		environment: data?.environment ?? "development",
	});
}
